import { Button, ButtonGroup, Col, Input, Label } from "reactstrap";
import { BoxButtonProp } from "../../../../types/Component";

const RadioBoxButton:React.FC<BoxButtonProp> = ({ item }) => {
  return (
    <Col xl="4" md="6" sm="12">
      <div className={item.btnClass}>
        <ButtonGroup>
          <Button color={item.colorClass}>
            <div className={item.divClass}>
              <Input id={item.id1} type="radio" name={item.name} value="option1" />
              <Label htmlFor={item.id1}>{item.title1}</Label>
            </div>
          </Button>
          <Button color={item.colorClass}>
            <div className={item.divClass}>
              <Input id={item.id2} type="radio" name={item.name} value="option1" defaultChecked />
              <Label htmlFor={item.id2}>{item.title2}</Label>
            </div>
          </Button>
        </ButtonGroup>
      </div>
    </Col>
  );
};

export default RadioBoxButton;